import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { championsApi } from 'src/app/shared/constants/api.constants';
import { HelpersService, HttpBaseService }   from '@evento-ng/libs';

@Component({
  selector: 'app-my-weapons',
  templateUrl: './my-tickets.component.html',
  styleUrls: ['./my-tickets.component.scss'],
})
export class MyTicketsComponent implements OnInit {
  tabs: any[];
  activeIndex = 0;
  champions: any[] = [];
  filterForm: FormGroup;
  filter: any;
  selectAll = false;
  invoices = [];
  isMobile = false;
  constructor(
    public helpers: HelpersService,
    private spinner: NgxSpinnerService,
    private dataService: HttpBaseService,
    private formBuilder: FormBuilder
  ) {
    this.isMobile = window.screen.width <= 768;
  }
  ngOnInit(): void {
    this.tabs = [
      {
        title: 'Events',
        active: true,
      },
      {
        title: 'Matches',
        active: false,
      },
    ];
    console.log('Dsf');

    this.initform();
  }

  private initform() {
    this.filterForm = this.formBuilder.group({
      ticketType: [''],
      championId: [''],
    });
    this.getAllChampions();
  }

  toggleSelectAll() {
    this.selectAll = !this.selectAll;
  }
  onFilterChange() {
    const currentTicketStatus =
      this.filterForm?.value?.ticketType === 'true'
        ? true
        : this.filterForm?.value?.ticketType === 'false'
        ? false
        : null;

    const championId = this.filterForm?.value?.championId || null;

    const params: any = {};

    if (currentTicketStatus !== null) {
      params.transferred = currentTicketStatus;
    }

    if (championId) {
      params.championId = championId;
    }
    this.filter = params;
  }

  changeTab(index: number) {
    this.activeIndex = index;
    this.selectAll = false;
    this.tabs = this.tabs.map((tab, i) =>
      i === index ? { ...tab, active: true } : { ...tab, active: false }
    );
  }

  getAllChampions() {
    this.spinner.show();
    this.dataService.get(`${championsApi}`).subscribe((res) => {
      this.champions = res.data;
      this.spinner.hide();
    });
  }
}
